/* This file is autogenerated, see readme.md for instructions */
import FileVideoSvgIcon from '@bloomreach/banana-theme/icons/file-video.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const FileVideoIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <FileVideoSvgIcon />
    </Icon>
  );
});

FileVideoIcon.displayName = 'FileVideoIcon';

export default FileVideoIcon;
